import React from "react";
import axios from "axios";
import HomeCover from "../components/HomeCover";
import Hilite from "../components/Hilite";
import HomeNews from "../components/HomeNews";
import HomeSlider from "../components/HomeSlider";
import HomeBanner from "../components/HomeBanner";
import FloatingButton from "../components/FloatingButton";
import HomeLelang from "../components/HomeLelang";
import HomePodcast from "../components/HomePodcast";
import HomePhotoshoot from "../components/HomePhotoshoot";
import HomeFooter from "../components/HomeFooter";
import HomeBannerButton from "../components/HomeBannerButton";
import PopupBanner from "../PopupBanner";
import NavbarHome from "../components/NavbarHome";
import CssLoader from "../components/CssLoader";
import Footer from "../components/Footer";
import { getArtistCookie, pageFilter } from "../data/page_data";
import Loading from "../components/loading";
import * as ReactGA from "react-ga";
import AdCashLoader from "./adcash_loader";

class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.pageData = pageFilter(this.props.artist, "../");
    this.state = {};
  }

  componentDidMount() {
    //this.setState({menu: pageFilter(this.props.artist, '')});
    axios
      .get(
        "/w/api/" +
          this.pageData.artist.id +
          "/home?x=" +
          this.pageData.artist.exclusive,
        {
          headers: {
            PortalAuth: getArtistCookie(this.props.artist),
          },
        }
      )
      .then((response) => {
        var respData = response.data;
        this.setState((state) => ({ data: respData }));
      });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <>
        {this.pageData.artist.id && (
          <AdCashLoader //adlib nya newmed
            zoneId={
              {
                20: "k1a5jfp5ts", //kayes
                21: "mrzgx0kqdh", //punipun
              }[this.pageData.artist.id]
            }
          />
        )}
        <CssLoader css={this.pageData.artist.css} />
        <NavbarHome data={this.pageData} />
        {!this.state.data ? (
          <>
            <Loading />
            <Footer />
          </>
        ) : (
          <>
            <HomeCover cover={this.pageData.artist.cover} />
            <div className="home-wrapper">
              {this.pageData.artist.popup_banner_url && (
                <>
                  <PopupBanner 
                    sms={this.pageData.artist.sms} 
                    imageUrl={this.pageData.artist.popup_banner_url} 
                  />
                </>
              )}
              {this.state.data.hotbig && (
                <Hilite
                  hotbig={this.state.data.hotbig}
                  hot={this.state.data.hot}
                />
              )}
              {this.state.data.news && (
                <HomeNews
                  data={this.state.data.news}
                  nick={this.pageData.artist.nick}
                />
              )}
              {this.state.data.videos && (
                <HomeSlider
                  data={this.state.data.videos}
                  nick={this.pageData.artist.nick}
                />
              )}
              {this.state.data.promo && (
                <HomeBanner
                  data={this.state.data.promo}
                  nick={this.pageData.artist.nick}
                  url={
                    this.pageData.artist.motion_url == null
                      ? "../event"
                      : this.pageData.artist.motion_url
                  }
                />
              )}
                {this.pageData.artist.sms && (this.pageData.artist.id == 29 || this.pageData.artist.id == 30) && (
                <>
                    <HomeBannerButton sms={this.pageData.artist.sms} />
                </>
                )}
              {this.state.data.auctions && (
                <HomeLelang
                  data={this.state.data.auctions}
                  nick={this.pageData.artist.nick}
                />
              )}
              {this.state.data.podcast && (
                <HomePodcast
                  artist={this.props.artist}
                  data={this.state.data.podcast}
                  nick={this.pageData.artist.nick}
                />
              )}
              {this.state.data.photo && (
                <HomePhotoshoot
                  data={this.state.data.photo}
                  nick={this.pageData.artist.nick}
                />
              )}
              {this.pageData.artist.floating_url && (
                <FloatingButton url={this.pageData.artist.floating_url} />
              )}

              <HomeFooter
                data={this.state.data.footer}
                name={this.pageData.artist.name}
                footer={this.pageData.artist.footer}
              />
              <Footer />
            </div>
          </>
        )}
      </>
    );
  }
}

export default HomePage;
